import React, { useState } from 'react';

export default function VetHelperAiEmbed() {
  const [showPopup, setShowPopup] = useState(true);
  
  // Streamlit Community Cloud doğrudan gömme URL'si
  const embedUrl = "https://vetapperai-vqcg597apptksmz7hy9odzk.streamlit.app/?embed=true";

  return (
    <div style={containerStyle}>
      {/* ŞIK VE TAM ORTALANMIŞ POPUP BİLGİLENDİRME */}
      {showPopup && (
        <div style={popupOverlayStyle}>
          <div style={popupCardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <span style={{ fontSize: '18px' }}>🤖</span>
              <button onClick={() => setShowPopup(false)} style={closeIconStyle}>✕</button>
            </div>
            <h4 style={{ margin: '0 0 8px 0', color: '#2c3e50', fontSize: '15px' }}>VetHelper AI Asistan</h4>
            <p style={{ margin: '0 0 15px 0', color: '#576574', fontSize: '13px', lineHeight: '1.5' }}>
              Asistan uyku modundaysa ekranda beliren mavi <b>"Yes, get this app back up!"</b> butonuna dokunabilirsiniz.
            </p>
            <button onClick={() => setShowPopup(false)} style={popupBtnStyle}>
              Anladım, Kapat
            </button>
          </div>
        </div>
      )}

      <iframe
        id="ai-iframe"
        src={embedUrl}
        frameBorder="0"
        width="100%"
        height="100%"
        title="VetHelper AI Chat"
        style={iframeStyle}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
        allowFullScreen
      ></iframe>
    </div>
  );
}

// --- Tasarım (Stil) Ayarları ---
const containerStyle = {
  width: '100%',
  height: 'calc(100vh - max(50px, env(safe-area-inset-top)) - 75px)', 
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#f8f9fa',
  boxSizing: 'border-box',
  padding: '10px',
  position: 'relative',
  paddingBottom: 'max(10px, env(safe-area-inset-bottom))'
};

const popupOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center', // Tam dikey ortalama
  backgroundColor: 'rgba(0, 0, 0, 0.2)', // Arkaya hafif şık bir karartma (blur hissi)
  boxSizing: 'border-box',
  padding: '20px'
};

const popupCardStyle = {
  background: '#ffffff',
  padding: '20px',
  borderRadius: '14px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
  maxWidth: '360px',
  width: '100%',
  border: '1px solid #e1e4e8',
  boxSizing: 'border-box'
};

const closeIconStyle = {
  background: 'none',
  border: 'none',
  fontSize: '16px',
  color: '#95a5a6',
  cursor: 'pointer',
  fontWeight: 'bold',
  padding: '0',
  WebkitTapHighlightColor: 'transparent'
};

const popupBtnStyle = {
  width: '100%',
  padding: '10px',
  background: '#2c3e50',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 'bold',
  fontSize: '13px',
  cursor: 'pointer',
  transition: 'background 0.2s',
  WebkitTapHighlightColor: 'transparent',
  boxSizing: 'border-box'
};

const iframeStyle = {
  width: '100%',
  flexGrow: 1,
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  boxSizing: 'border-box'
};